import {ParovaniActions, LogovaniApiActions} from '@mc/poh';
import {base, utils} from '@mc/redux';
import {DetailReducer} from 'mc/lib/detail';
import {InfiniteListReducer, SimpleListReducer} from 'mc/lib/list';
import * as PlatbaActions from '../actions/platbaActions';
import * as PlatbaListActions from '../actions/platbaListActions';
import * as ZadostActions from '../actions/zadostActions';
import * as ZadostListActions from '../actions/zadostListActions';
import * as StavPlatby from '../api/StavPlatby';

const defaultPlatbaListFilter = {
    stavPlatby: StavPlatby.NEVYPORADANO,
    cisloDokladu: '',
    vs: '',
    datumPlatby: null,
};

const defaultZadostListFilter = {
    pouzeNevyrovnane: true,
    drzitel: null,
    vs: '',
    cislo: '',
};

const defaultLogListFilter = {
    datumCasVolaniOd: null,
    datumCasVolaniDo: null,
    sluzba: LogovaniApiActions.NEROZHODUJE_VALUE,
    stav: LogovaniApiActions.NEROZHODUJE_VALUE,
    parametryVstup: '',
    parametryVystup: '',
    popisChyby: '',
};

// Počáteční definice aplikačního store
const initialState = {
    ...base.BaseReducer(),   // APP BASE
    [ParovaniActions.PLATBY_LIST_AREA]: SimpleListReducer(),
    [ParovaniActions.BANKOVNI_UCTY_LIST_AREA]: SimpleListReducer(),
    [PlatbaListActions.PLATBA_LIST_AREA]: InfiniteListReducer(undefined, undefined, {filter: defaultPlatbaListFilter}),
    [PlatbaActions.PLATBA_AREA]: DetailReducer(),
    [PlatbaActions.PLATBA_VYROVNANI_LIST_AREA]: SimpleListReducer(),
    [PlatbaActions.PLATBA_VRATKA_LIST_AREA]: SimpleListReducer(),
    [ZadostListActions.ZADOST_LIST_AREA]: InfiniteListReducer(undefined, undefined, {filter: defaultZadostListFilter}),
    [ZadostActions.ZADOST_AREA]: DetailReducer(),
    [ZadostActions.ZADOST_PLATBA_LIST_AREA]: SimpleListReducer(),
    [LogovaniApiActions.CALL_LOG_LIST_AREA]: InfiniteListReducer(undefined, undefined, {filter: defaultLogListFilter}),
    [LogovaniApiActions.CALL_LOG_SLUZBA_LIST_AREA]: SimpleListReducer(),
};

/**
 * Hlavní store aplikace.
 */
export default function app(state = initialState, action) {
    if (action && action.area) {
        return utils.processAreaStores(state, action);
    }
    return state;
}
